import Vue from 'vue';
import App from './App.vue';
import Landing from './Landing.vue';
import VueRouter from 'vue-router';
import Albums from './Albums.vue';
import About from './About.vue';
import Gallery from './Gallery.vue';
import Services from './Services.vue';
import VueMasonry from 'vue-masonry-css';
import vGallery from 'v-gallery';

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(vGallery);
Vue.use(VueMasonry);

const routes = [
    {path: '/', component: Landing},
    {path: '/gallery&id=:id', component: Gallery},
    {path: '/albums', component: Albums},
    {path: '/about', component: About},
    {path: '/services', component: Services},
    {path: '*', component: Landing}
];

const router = new VueRouter({routes});

new Vue({
    router,
    render: h => h(App),
}).$mount('#app');

